import { Input as AntdInput } from 'antd';
import { defaultProps, InputProps } from './Input.type';
import style from "./Input.module.scss";

export const Input = (props: InputProps) => {
  const { ...attributes } = { ...defaultProps, ...props }

  return <AntdInput {...attributes} className={style.Input} />
};

